<template>
  <div class="container mb-5">
    <Breadcrumb :title="$t('miga.MyTickets')" />
    <HeadingBox
      :title="$t('miscitas.title')"
      :description="$t('miscitas.descr')"
    />

    <div class="col-12">
      <div class="m-t-30">
        <form class="widget-contact-form" role="form" novalidate="novalidate">
          <div class="row">
            <div class="form-group col-md-6">
              <label for="name" v-html="$t('telmovil')" />
              <input
                id="visitorMobile"
                type="text"
                aria-required="true"
                name="widget-contact-form-name"
                class="form-control required name"
                v-model="visitorMobile"
                :placeholder="$t('miscitas.introdmovil')"
              />
            </div>
            <div class="form-group col-md-6">
              <label for="email" v-html="$t('correoe')" />
              <input
                id="visitorEmail"
                type="email"
                aria-required="true"
                name="widget-contact-form-email"
                class="form-control required email"
                v-model="visitorEmail"
                :placeholder="$t('miscitas.introdemail')"
              />
            </div>
          </div>

          <a href="#" class="btn btn-upvehu-negro p-2 my-3 float-right" @click="buscarMisTickets()">
             Enviar <span class="mx-2"></span> <i class="fa fa-chevron-right"></i>
          </a>
          <!--
          <a href="#" class="btn float-right" ___click="subscribirseWebPush()">
            <i class="fa fa-paper-plane"></i> Subscribirse
          </a>
          -->
          <br />
          <br />
        </form>
      </div>
    </div>

    <AlertaError class="mt-5 mb-5" />

    <HeadingBox class="mt-4" v-if="tickets" :title="$t('resultados')" :description="(tickets || []).length ? $t('miscitas.haycitas') : $t('miscitas.nohaycitas')" role="alert" aria-atomic="true">
      <strong v-if="citaVideoConferenciaAhora">
        Tiene usted una cita previa a través de videollamada. Por favor, pulse en el botón para incorporarse.
        <a @click="Utils.iniciarVideoconferencia(citaVideoConferenciaAhora)" class="btn btn-upvehu-blanco px-3 my-4" style="width: 100%"><i class="fa fa-video mx-2"></i> Acceder a mi videoconferencia</a>
      </strong>
    </HeadingBox>


    <div class="row mt-3" v-if="(tickets || []).length">
      <Ticket
        v-for="ticket in tickets"
        :key="ticket.id"
        :ticket="ticket"
        :tenant="tenant"
        class="col-lg-6"
        @cancelTicket="buscarMisTickets()"
        :showButtons="true"
      />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import HeadingBox from "@/components/HeadingBox.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import AlertaError from "@/components/AlertaError.vue";
import Utils from "@/services/Utils.js";
import APIPortal from "@/services/APIPortal.js";


import Ticket from "@/components/Ticket.vue";
import Session from "@/session/Session.js";

export default {
  name: "Landing",
  components: {
    HeadingBox,
    Breadcrumb,
    AlertaError,
    Ticket },
  props: {},
  computed: {},
  data: () => ({
    Utils,
    tenant: Session.getTenant(),
    visitorMobile: null,
    visitorEmail: null,
    tickets: null,
    watchDogInterval: null,
    citaVideoConferenciaAhora: null
  }),
  async mounted() {
    window.addEventListener("language.changed", () => Vue.nextTick(this.init));

    this.watchDogInterval = setInterval(
      function () {
        this.calculateStatus();
      }.bind(this),
      5 * 1000
    );

    this.init()
  },
  beforeDestroy() {
    clearInterval(this.watchDogInterval);
    window.removeEventListener('language.changed', this.init);
  },
  methods: {
    async init () {
      await Utils.initPortal(this, false)
      await APIPortal.getTeleconfURL()
      this.prefillForm()
      if (this.visitorMobile && this.visitorEmail) {
        await this.buscarMisTickets();
        this.calculateStatus();
      }

    },

    prefillForm() {
      let o = JSON.parse(window.localStorage.getItem('noq::personalData') || '{}')
      window.console.log('Precargando datos personales ..')
      window.console.table(o)
      let v = Session.getVisitor() || {}
      this.visitorEmail = this.visitorEmail || o.visitorEmail || v.visitorEmail
      this.visitorMobile = this.visitorMobile || o.visitorMobile || v.visitorMobile
    },

    calculateStatus() {
      window.console.log("Calculando status tickets ..");

      Vue.set(this, "citaVideoConferenciaAhora", null);
      window._.each(this.tickets, (t) => {
        let ic = Utils.intervaloCortesiaAbierto(t)
        Vue.set(t, "enIntervaloCortesia", ic);
        if (Utils.puedoIniciarVideoconferencia(t))
          Vue.set(this, "citaVideoConferenciaAhora", t);
      });
    },
    async buscarMisTickets() {
      let v = Session.getVisitor();
      v.visitorMobile = this.visitorMobile;
      v.visitorEmail = this.visitorEmail;

      let res = await APIPortal.myTickets({
        visitorMobile: this.visitorMobile,
        vatID: this.visitorVatID,
        email: this.visitorEmail,
      });
      this.tickets = res.data;
      this.calculateStatus()
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.card-img-top {
}
</style>

